import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import apiClient from '../../config/axiosConfig';
import _actions from '../../actions';
import VersionFree from '../../components/structure/VersionFree';
import i18n from '../../i18n';
import twitter from '../../assets/styles/img/svg/twitter.svg';
import facebook from '../../assets/styles/img/svg/facebook.svg';
import googleplus from '../../assets/styles/img/svg/googleplus.svg';
import pinterest from '../../assets/styles/img/svg/pinterest.svg';
import PageBreak from '../../components/structure/PageBreak';
import LargeLoading from '../../components/svg/LargeLoading';

class PromotePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            landing: {},
        };
    }

    componentDidMount() {
        if (this.props.projects.data.length === 0) {
            this.props.actions.getProjects();
        }

        document.body.classList.add('promote-page', 'version-free');
        this.props.actions.getEmbedCode();
        apiClient.get(`/v2/organizations/hashId/${this.props.profiles.data.organizationId}`)
            .then((response) => {
                this.setState({
                    landing: response.data.data,
                });
            })
            .catch(() => {
                this.setState({
                    landing: {},
                });
            });
    }

    componentWillUnmount() {
        document.body.classList.remove('promote-page', 'version-free');
    }

    copyToClipboard = () => {
        this.textArea.select();
        document.execCommand('copy');
    };

    copyLinkToClipboard = () => {
        const copyText = document.getElementById('landing-url');
        const el = document.createElement('textarea');
        el.value = copyText.innerHTML;
        el.setAttribute('readonly', '');
        el.style = {
            position: 'absolute',
            left: '-9999px',
        };
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    render() {
        return (
            <VersionFree alerts={this.props.alerts}>
                {this.props.projects.inProgress
                && (
                    <div id="loading-page">
                        <div id="loading-container_loader">
                            <LargeLoading />
                        </div>
                    </div>
                )}
                {this.props.projects.data.filter(
                    (project) => { return project.liveVersion; },
                ).length > 0
                && (
                    <div data-qa="promote-page" id="promote-page" className="form-wrapper">
                        <h1
                            data-qa="promote-page-header"
                            id="promote-page-header"
                            className="status"
                        >
                            {i18n.t('promote.promote')}
                        </h1>
                        <p
                            data-qa="promote-subhead"
                            id="promote-page-subhead"
                            className="lead has-decoration"
                        >
                            {i18n.t('promote.subheader')}
                        </p>

                        <p
                            data-qa="promote-intro"
                            id="promote-page-intro"
                            className="status subtitle text-center"
                        >
                            {i18n.t('promote.intro')}
                        </p>
                        <h2
                            data-qa="promote-linkit"
                            id="promote-page-link-it"
                        >
                            {i18n.t('promote.link-it')}
                        </h2>
                        <p
                            data-qa="promote-page-link-copy"
                            id="promote-page-link-copy"
                        >
                            {i18n.t('promote.link-copy')}
                        </p>
                        <textarea
                            data-qa="promote-page-iframe-copy"
                            id="promote-page-iframe-copy"
                            ref={(textarea) => {
                                // eslint-disable-next-line no-return-assign
                                return this.textArea = textarea;
                            }}
                            readOnly
                            value={this.props.organization.data}
                        />
                        {/* eslint-disable-next-line */}
                        <a
                            data-qa="promote-page-copy-button"
                            id="promote-page-copy-button"
                            className="btn btn-sq btn-sm btn-dark text-center has-decoration"
                            onClick={this.copyToClipboard}
                        >
                            {i18n.t('promote.copy')}
                        </a>
                        <PageBreak />
                        <h2 data-qa="promote-landing-header">{i18n.t('promote.share-public')}</h2>
                        <p data-qa="promote-landing-copy">{i18n.t('promote.share-copy')}</p>
                        <p>
                            <a
                                id="landing-url"
                                data-qa="promote-landing-link"
                                href={`${window.location.protocol}//${window.location.host}/landing/${this.state.landing.hashId ? this.state.landing.hashId : ''}`}
                            >
                                {`${window.location.protocol}//${window.location.host}/landing/${this.state.landing.hashId ? this.state.landing.hashId : ''}`}
                            </a>
                        </p>
                        {/* eslint-disable-next-line  */}
                        <a
                            data-qa="promote-link-copy-button"
                            id="promote-link-copy-button"
                            className="btn btn-sq btn-sm btn-dark text-center has-decoration"
                            onClick={this.copyLinkToClipboard}
                        >
                            {i18n.t('promote.share-button')}
                        </a>
                        <PageBreak />

                        {false && (
                            <div className="removeMeLater">
                                <h1>{i18n.t('promote.share-it')}</h1>
                                <p className="copy status social subtitle text-center">{i18n.t('promote.social-copy')}</p>
                                <p className="status social subtitle text-center">
                                    <a
                                        className="twitter"
                                        href="http://twitter.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={`${twitter}`} alt="twitter" />
                                    </a>
                                    <a
                                        className="facebook"
                                        href="http://facebook.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={`${facebook}`} alt="facebook" />
                                    </a>
                                    <a
                                        className="gplus"
                                        href="http://plus.google.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={`${googleplus}`} alt="googleplus" />
                                    </a>
                                    <a
                                        className="pinterest"
                                        href="http://pinterest.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={`${pinterest}`} alt="pinterest" />
                                    </a>
                                </p>
                            </div>
                        )}
                    </div>
                )}
                {!this.props.projects.inProgress && this.props.projects.data.filter(
                    (project) => { return project.liveVersion; },
                ).length === 0
                && (
                    <div data-qa="promote-page-nolive" id="promote-page" className="form-wrapper">
                        <h1
                            data-qa="promote-page-header-nolive"
                            id="promote-page-header"
                            className="status"
                        >
                            {i18n.t('promote.promote')}
                        </h1>
                        <p
                            data-qa="promote-page-subhead-nolive"
                            id="promote-page-subhead-"
                            className="lead has-decoration"
                        >
                            {i18n.t('promote.subheader-unpublished')}
                        </p>

                        <p
                            data-qa="promote-page-intro-nolive"
                            id="promote-page-intro"
                            className="status subtitle text-center"
                        >
                            {i18n.t('promote.intro-unpublished')}
                        </p>
                    </div>
                )}
            </VersionFree>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotePage);
